module.exports = __webpack_public_path__ + "static/04-070857394250b0ff82d32bba47c1660b.jpg";